// dependent on span in navbar: <span id="voice" hidden data-language= ... "
// TO DO: Convert to js.erb to remove navbar dependency
export let language = document.getElementById("voice")
  ? document.getElementById("voice").dataset.language
  : "en";
